import { Footer } from '@awaze/design-system.compositions.footer'
import { PanelProps } from '@awaze/design-system.compositions.footer/dist/footer.types'
import { LinkProps } from '@awaze/design-system.compositions.responsive-header/dist/navigation-item/navigation-item.types'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import parse from 'html-react-parser'
import { FC, ReactElement, ReactNode } from 'react'
import { FooterData } from '../../../pages/_app'
import { IFooterLabels } from '@awaze/design-system.compositions.footer/footer.types'
import { Document } from '@contentful/rich-text-types'

export interface FooterWrapperProps {
  footerData: FooterData | null
}

export const FooterWrapper: FC<FooterWrapperProps> = ({
  footerData,
}: FooterWrapperProps): ReactNode => {
  const companyInformation =
    footerData?.companyInformation?.content &&
    documentToHtmlString(footerData.companyInformation as unknown as Document)

  return (
    <Footer
      labels={{
        menu: footerData?.menu as unknown as IFooterLabels['menu'],
        socialMediaIcons:
          footerData?.socialMediaIcons as unknown as LinkProps[],
        termsAndConditions:
          footerData?.termsAndConditions as unknown as LinkProps,
        panels: footerData?.panels as unknown as PanelProps[],
        companyInformation: companyInformation ? (
          (parse(companyInformation as string) as ReactElement)
        ) : (
          <p></p>
        ),
      }}
    />
  )
}
